module.exports = __webpack_public_path__ + "media/personas/bg-cities-cb753ae0.jpg";